var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('BasePageHeader',{attrs:{"title":"新增優惠券"}}),_c('el-card',[_c('CouponForm',{on:{"back":_vm.backToList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }